/**
 *   Generated file. Do not edit
 */

import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  getCodeSize: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/jvm/code-size',
    path: '/1024//73',
    responseBodyDecoder: allConverters.uint32,
  } as ServiceCallType<void, number>,

  putCodeSize: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/jvm/code-size',
    path: '/1024//73',
    bodyEncoder: allConverters.uint32,
  } as ServiceCallType<number, void>,

  appendCode: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/jvm/code',
    append: true,
    path: '/1024//74',
  } as ServiceCallType<Uint8Array, void>,

  clearCode: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/jvm/clear-code',
    path: '/1024//74',
  } as ServiceCallType<void, void>,

  getProfileId: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/jvm/profile-id',
    path: '/1024//66',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putProfileId: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/jvm/profile-id',
    path: '/1024//66',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getLogAndClear: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/jvm/log-and-clear',
    path: '/1024//120',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  clearLog: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/jvm/log-and-clear',
    path: '/1024//120',
  } as ServiceCallType<void, void>,

  getLog: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/jvm/log',
    path: '/1024//121',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putLog: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/jvm/log',
    path: '/1024//121',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getErrorCode: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/jvm/error-code',
    path: '/3//14',
    responseBodyDecoder: allConverters.uint32,
  } as ServiceCallType<void, number>,

  postErrorCode: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/jvm/error-code',
    path: '/3//14',
    bodyEncoder: allConverters.uint32,
  } as ServiceCallType<number, void>,
};
